/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import styled from "styled-components";
import { Input2, DropDown2, ToggleButton, DecimalInput } from "components";
import { useInput } from "hooks";
import { formatDollarValue } from "utils/dataUtils";

export const IncentiveNextShoppingTripTextBuilder = ({
  className,
  value = "",
  onChange = () => {},
}) => {
  const start = useInput("7.00");
  const end = useInput("");
  const type = useInput("$");
  const isPurchase = useInput(true);
  const wType = useInput("");
  const wVal = useInput("");
  const suffix = useInput("");
  const typeData = [
    { id: "$", title: "$" },
    { id: "%", title: "%" },
  ];
  const typeData2 = [
    { id: "$", title: "$" },
    { id: "Unit", title: "Unit" },
  ];
  const formatValue = (s, e, t) => {
    if (!s) return "";
    return t === "$"
      ? `$${formatDollarValue(s)}${e ? `-$${formatDollarValue(e)}` : ""}`
      : `${s}${t}${e ? `-${e}${t}` : ""}`;
  };
  const handleUpdateValue = (s, e, t, isW, wv, wt, suf) => {
    onChange(
      `save ${formatValue(s, e, t)} on next shopping visit${
        isW ? ` w/purchase${wt === "Unit" ? `/${wv}` : `/$${formatDollarValue(wv)}`}` : ``
      }${suf ? ` ${suf}` : ""}`
    );
  };

  useEffect(() => {
    if (value.toLowerCase().startsWith("save")) {
      let main = value.slice(4).trimStart();
      const nextIndex = main.indexOf("on next shopping visit");
      const vt = main.slice(0, nextIndex).trim();
      if (vt) {
        if (vt.startsWith("$")) {
          type.setValue("$");
          const parts = vt.split("-");
          start.setValue(parts[0].replace("$", "").trim());
          end.setValue(parts[1] ? parts[1].replace("$", "").trim() : "");
        } else if (vt.endsWith("%")) {
          type.setValue("%");
          const parts = vt.split("-");
          start.setValue(parts[0].replace("%", "").trim());
          end.setValue(parts[1] ? parts[1].replace("%", "").trim() : "");
        }
      } else {
        type.setValue("");
        start.setValue("");
        end.setValue("");
      }
      main = main.slice(nextIndex + 22).trimStart();
      if (main.startsWith("w/purchase/")) {
        isPurchase.setValue(true);
        main = main.slice(11).trimStart();
        const sufIndex = main.indexOf(" ");
        let wv = "";
        if (sufIndex > 0) {
          wv = main.slice(0, sufIndex).trim();
          suffix.setValue(main.slice(sufIndex + 1).trimStart());
        } else {
          wv = main.trim();
          suffix.setValue("");
        }
        if (wv.startsWith("$")) {
          wType.setValue("$");
          wVal.setValue(wv.slice(1).trim());
        } else {
          wType.setValue("Unit");
          wVal.setValue(wv);
        }
      } else if (main.startsWith("w/purchase ")) {
        isPurchase.setValue(true);
        wType.setValue("$");
        main = main.slice(11).trimStart();
        const sufIndex = main.indexOf(" ");
        if (sufIndex > 0) {
          wVal.setValue(main.slice(1, sufIndex).trim());
          suffix.setValue(main.slice(sufIndex + 1).trimStart());
        } else {
          wVal.setValue(main.slice(1).trim());
          suffix.setValue("");
        }
      } else {
        suffix.setValue(main.trimStart());
      }
    }
    return () => {};
  }, [value]);

  return (
    <div className={`${className} mt-1 py-2`}>
      <Title>Incentive Text Builder</Title>
      <Container className="mt-2">
        <div className="mt-auto mb-2">Save</div>

        <div style={{ width: 60, marginLeft: 10 }}>
          {type.value === "$" ? (
            <DecimalInput
              label="Start Value"
              value={start.value}
              onChange={(e) => {
                start.setValue(e);
                handleUpdateValue(
                  e,
                  end.value,
                  type.value,
                  isPurchase.value,
                  wVal.value,
                  wType.value,
                  suffix.value
                );
              }}
            />
          ) : (
            <Input2
              label="Start Value"
              value={start.value}
              type="float"
              onChange={(e) => {
                start.setValue(e);
                handleUpdateValue(
                  e,
                  end.value,
                  type.value,
                  isPurchase.value,
                  wVal.value,
                  wType.value,
                  suffix.value
                );
              }}
            />
          )}
        </div>
        <div className="mt-auto mb-2 px-1">-</div>
        <div style={{ width: 60 }}>
          {type.value === "$" ? (
            <DecimalInput
              label="End Value"
              value={end.value}
              onChange={(e) => {
                end.setValue(e);
                handleUpdateValue(
                  start.value,
                  e,
                  type.value,
                  isPurchase.value,
                  wVal.value,
                  wType.value,
                  suffix.value
                );
              }}
            />
          ) : (
            <Input2
              label="End Value"
              value={end.value}
              type="float"
              onChange={(e) => {
                end.setValue(e);
                handleUpdateValue(
                  start.value,
                  e,
                  type.value,
                  isPurchase.value,
                  wVal.value,
                  wType.value,
                  suffix.value
                );
              }}
            />
          )}
        </div>
        <div style={{ width: 70, marginLeft: 10 }}>
          <DropDown2
            label="Type"
            data={typeData}
            width={70}
            value={type.value}
            onChange={(e) => {
              const nextStart = e === "$" ? formatDollarValue(start.value) : start.value;
              const nextEnd = e === "$" ? formatDollarValue(end.value) : end.value;
              type.setValue(e);
              start.setValue(nextStart);
              end.setValue(nextEnd);
              handleUpdateValue(
                nextStart,
                nextEnd,
                e,
                isPurchase.value,
                wVal.value,
                wType.value,
                suffix.value
              );
            }}
          />
        </div>
        <div className="mt-auto mb-2 ml-1" style={{ fontSize: 12 }}>
          on next shopping visit
        </div>
      </Container>
      <Container className="mt-1">
        <ToggleButton
          label="w/purchase"
          className="mt-auto mb-2"
          value={isPurchase.value}
          onChange={(e) => {
            isPurchase.setValue(e);
            handleUpdateValue(
              start.value,
              end.value,
              type.value,
              e,
              wVal.value,
              wType.value,
              suffix.value
            );
          }}
        />

        <div style={{ width: 60, marginLeft: 10 }}>
          {wType.value === "$" ? (
            <DecimalInput
              label="Value"
              value={wVal.value}
              disabled={!isPurchase.value}
              onChange={(e) => {
                wVal.setValue(e);
                handleUpdateValue(
                  start.value,
                  end.value,
                  type.value,
                  isPurchase.value,
                  e,
                  wType.value,
                  suffix.value
                );
              }}
            />
          ) : (
            <Input2
              label="Value"
              value={wVal.value}
              type="float"
              disabled={!isPurchase.value}
              onChange={(e) => {
                wVal.setValue(e);
                handleUpdateValue(
                  start.value,
                  end.value,
                  type.value,
                  isPurchase.value,
                  e,
                  wType.value,
                  suffix.value
                );
              }}
            />
          )}
        </div>
        <div style={{ width: 70, marginLeft: 10 }}>
          <DropDown2
            label="Type"
            data={typeData2}
            width={70}
            value={wType.value || "Unit"}
            disabled={!isPurchase.value}
            onChange={(e) => {
              wType.setValue(e);
              handleUpdateValue(
                start.value,
                end.value,
                type.value,
                isPurchase.value,
                wVal.value,
                e,
                suffix.value
              );
            }}
          />
        </div>
        <div style={{ width: 80, marginLeft: 10 }}>
          <Input2
            label="Suffix"
            value={suffix.value}
            onChange={(e) => {
              suffix.setValue(e);
              handleUpdateValue(
                start.value,
                end.value,
                type.value,
                isPurchase.value,
                wVal.value,
                wType.value,
                e
              );
            }}
          />
        </div>
      </Container>
    </div>
  );
};

const Title = styled.div`
  color: #66c0e1;
  font-size: 16px;
`;
const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  padding: 8px;
  display: flex;
`;
